/** Shared by the assignment screens. */

export const WINDOW_COLOUR: Record<string, 'default' | 'info' | 'success' | 'warning' | 'error'> = {
    upcoming: 'info',
    open: 'success',
    closed: 'default',
    draft: 'warning',
    cancelled: 'error',
};

export const RESULT_MODES = [
    { id: 'after_window', name: 'After the window closes' },
    { id: 'immediately', name: 'As soon as each student submits' },
    { id: 'manual', name: 'When I release them' },
    { id: 'never', name: 'Never (teachers only)' },
];

/** A student's state on an assignment, as a teacher reads it. */
export const STATE: Record<string, { label: string; colour: 'default' | 'info' | 'success' | 'warning' | 'error' }> = {
    assigned: { label: 'not started', colour: 'default' },
    in_progress: { label: 'writing now', colour: 'info' },
    submitted: { label: 'submitted', colour: 'success' },
    auto_submitted: { label: 'time ran out', colour: 'success' },
    missed: { label: 'missed', colour: 'warning' },
    excused: { label: 'excused', colour: 'default' },
};
